application.register("comp_services_list", class extends Stimulus.Controller {
  connect() {
    const self = this;
    this._items = self.targets.findAll('item')

    this.setItemHeights()

    this._resizeObserver = new ResizeObserver(() => {
      this.setItemHeights()
    })

    this._resizeObserver.observe(document.documentElement);
  }

  setItemHeights() {
    this._items.forEach(item => {
      item.style.setProperty('--height', item.scrollHeight + 'px');
    })
  }

  disconnect() {
    this._resizeObserver.disconnect();
  }
})
